import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<a
    [attr.title]="data?.publisherName"
    enTooltip
    [routerLink]="discoveryRouterLink"
    [queryParams]="{ developerName: data?.publisherName }"
  >
    {{ data?.publisherName }}
  </a>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublisherNameComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  ngOnInit(): void {
    super.ngOnInit();
  }
}
